import type { CityConfig } from "../city-template/types";

export const molineConfig: CityConfig = {
  city: "Moline",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "moline",
  route: "/moline",
  title: "Emergency Passport Moline, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Moline, Illinois — as fast as 24 hours. Fast passport renewal for John Deere employees, Quad Cities International Airport travelers, and all Rock Island County residents. A+ BBB rated registered State Dept. courier serving the Quad Cities.",
  h1: "Emergency & Expedited Passport Services in Moline, IL",
  heroSubtitle: "John Deere executive trip to Germany in 4 days and your passport's damaged? Quad Cities family vacation to Italy and the kids' passports expired? Living in John Deere's world headquarters city doesn't help when you need a passport overnight. We help Moline residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving Rock Island County and the entire Quad Cities region.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Moline%20Illinois%20downtown%20featuring%20the%20Mississippi%20River%20waterfront%20and%20the%20iconic%20John%20Deere%20Pavilion%2C%20the%20I-74%20bridge%20spanning%20the%20river%20with%20Quad%20Cities%20skyline%2C%20historic%20brick%20buildings%20along%20River%20Drive%2C%20vibrant%20riverfront%20with%20parks%20and%20walking%20paths%2C%20dramatic%20Midwest%20sunset%20over%20the%20Mississippi%2C%20professional%20landscape%20photography%2C%20showcase%20of%20the%20Quad%20Cities%20metropolitan%20riverfront%20community&width=1800&height=700&seq=moline-hero-001&orientation=landscape",
  heroImageAlt: "Moline Illinois downtown riverfront with John Deere Pavilion and Mississippi River at sunset",
  geoPosition: "41.4900;-90.5150",
  geoPlacename: "Moline, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 2 hours 45 minutes east of Moline via I-88 / I-290",
  },
  nearbyCitiesZips: [
    { name: "Moline", zips: "61265, 61266" },
    { name: "Rock Island", zips: "61201, 61204" },
    { name: "East Moline", zips: "61244" },
    { name: "Silvis", zips: "61282" },
    { name: "Carbon Cliff", zips: "61239" },
    { name: "Hampton", zips: "61256" },
    { name: "Port Byron", zips: "61275" },
    { name: "Coal Valley", zips: "61240" },
    { name: "Orion", zips: "61273" },
    { name: "Milan", zips: "61264" },
    { name: "Geneseo", zips: "61254" },
    { name: "Colona", zips: "61241" },
    { name: "Davenport, IA", zips: "52801, 52802, 52803, 52804, 52806, 52807" },
    { name: "Bettendorf, IA", zips: "52722" },
    { name: "Eldridge, IA", zips: "52748" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — under 3 hours away but you skip the trip entirely" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Quad Cities travelers" },
    { icon: "ri-building-4-line", title: "John Deere & Corporate Hub", desc: "Serving John Deere World HQ, corporate travelers, and Quad Cities business professionals" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Ship from any UPS or FedEx in Moline — no 5.5-hour Chicago round trip required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Davenport, IA", route: "/davenport" },
    { name: "Emergency passport help in Rock Island, IL", route: "/rock-island" },
    { name: "Urgent passport services in Peoria, IL", route: "/peoria" },
    { name: "Illinois passport services overview", route: "/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Moline, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (2 hours 45 minutes east via I-88 and I-290) — without you making the trip. Moline residents can ship from any UPS or FedEx in Rock Island County. For Quad Cities travelers, our courier service saves half a day of driving and downtown Chicago navigation.",
  fpcOfficeDistance: "Serving Moline, Rock Island, East Moline, Silvis, Carbon Cliff, Hampton, Port Byron, Coal Valley, Orion, Milan, Geneseo, Colona, Davenport IA, Bettendorf IA, Eldridge IA, and the entire Quad Cities metropolitan area",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Moline and the entire Quad Cities region. From the John Deere World Headquarters and downtown Moline riverfront to the Quad Cities International Airport, from the residential neighborhoods near Black Hawk College to the Mississippi River communities — we serve all of Rock Island County and both sides of the Quad Cities metropolitan area.",
  nearbyCitiesIntro: "We serve Moline and all nearby communities including Rock Island, East Moline, Silvis, Carbon Cliff, Hampton, Port Byron, Coal Valley, Orion, Milan, Geneseo, and Colona. We also serve Davenport, Bettendorf, and Eldridge, Iowa, and the entire Quad Cities region.",
  howItWorksIntro: "Most Moline travelers complete everything online and ship documents overnight. No need to drive nearly 3 hours to Chicago — our couriers handle the Chicago Passport Agency trip for you. For Quad Cities residents, this saves a full half-day of travel.",
  mistakesIntro: "Moline is home to John Deere's World Headquarters with thousands of executives, engineers, and professionals traveling internationally every week — yet the nearest passport agency is nearly 3 hours away. Here are the most common passport mistakes in the Quad Cities.",
  testimonialsIntro: "Moline travelers — from John Deere executives and Quad Cities business professionals to Augustana College families and QC Airport international travelers — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Moline, IL? Here are the most common ones we hear from Quad Cities travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "5.5+ hour round trip drive to Chicago", "Impractical for most Quad Cities residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No 5.5-hour round trip to Chicago required", "Perfect for John Deere executive travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Moline travelers with immediate departure needs — as fast as 24 hours. Essential for John Deere executives and Quad Cities business travelers with last-minute international trips.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No 5.5-hour Chicago round trip — ship locally"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Moline adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Moline address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Moline residents — including Black Hawk College students, new citizens, and Quad Cities families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Moline residents who lost their passport before international business travel or family vacation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Moline and Rock Island County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Moline and Rock Island County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized passport card for Moline residents who need land/sea travel to Canada or Mexico — ideal for quick North American trips.",
      bullets: ["Land and sea travel to Canada, Mexico, Caribbean", "Wallet-sized convenience", "REAL ID compliant"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Passport replacement for Moline residents with water-damaged, torn, or otherwise damaged passports that need urgent replacement.",
      bullets: ["DS-11 form with damage explanation", "Photo verification for identity matching", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Second valid passport book for Moline business travelers and John Deere executives who need a backup while one is with an embassy for visa processing.",
      bullets: ["Second valid passport book", "Ideal for frequent international executives", "Keep traveling while visa processes"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Moline IL", description: "Urgent passport processing for Moline Illinois travelers and John Deere professionals with immediate departure needs." },
    { name: "Expedited Passport Renewal Moline IL", description: "Fast passport renewal for Moline Illinois residents and Quad Cities travelers." },
    { name: "First-Time Passport Moline IL", description: "New passport application services for Moline Illinois residents." },
    { name: "Child Passport Moline IL", description: "Minor passport services for Moline Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jennifer S.",
      location: "Moline, IL — John Deere",
      rating: 5,
      text: "John Deere sent me to our Mannheim facility with 6 days notice and my passport had 3 months left — Germany requires 6 months validity. Fast Passport Center renewed it in 3 days. Shipped from UPS on John Deere Road. Made my meetings in Germany without a hitch. Every Deere employee should bookmark this service.",
      service: "Passport Renewal",
    },
    {
      name: "Marcus T.",
      location: "Moline, IL",
      rating: 5,
      text: "Family trip to Cancun leaving in 10 days and none of my kids had passports. Fast Passport Center got all 3 child passports in 5 days. The Moline post office appointment was smooth and they guided me through the whole process. Quad Cities families, this is the only way to do last-minute kid passports.",
      service: "Child Passport",
    },
    {
      name: "Rachel K.",
      location: "East Moline, IL",
      rating: 5,
      text: "Lost my passport somewhere between John Deere Pavilion and my house — had a London trip in 7 days. Fast Passport Center got me a replacement in 2 days. I was literally in a panic and they made it so easy. Shipped from East Moline and was at MLI airport by Friday. Incredible.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "mln-1",
      name: "Moline Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "514 17th St",
      city: "Moline",
      state: "IL",
      zip: "61265",
      phone: "(309) 764-7761",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Moline, Downtown near River Drive",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Moline acceptance facility. Convenient to downtown Moline, John Deere World HQ, and the riverfront. Appointments strongly recommended. Near the I-74 bridge.",
      icon: "ri-mail-line",
    },
    {
      id: "mln-2",
      name: "Rock Island County Circuit Clerk",
      type: "County Clerk Passport Acceptance",
      address: "13120 3rd St",
      city: "Rock Island",
      state: "IL",
      zip: "61201",
      phone: "(309) 558-3312",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Rock Island, Rock Island County Courthouse, approximately 2 miles west of Moline",
      website: "https://www.rockislandcounty.org/",
      websiteLabel: "Rock Island County Circuit Clerk",
      notes: "Rock Island County acceptance facility at the county seat. Located near downtown Rock Island and Augustana College. Call ahead to confirm passport acceptance hours.",
      icon: "ri-government-line",
    },
    {
      id: "mln-3",
      name: "Rock Island Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2633 11th St",
      city: "Rock Island",
      state: "IL",
      zip: "61201",
      phone: "(309) 788-9188",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Rock Island, approximately 3 miles west of Moline",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Rock Island and western Quad Cities. Extended hours until 5 PM. Good alternative to Moline post office with longer service hours.",
      icon: "ri-mail-line",
    },
    {
      id: "mln-4",
      name: "East Moline Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "805 16th Ave",
      city: "East Moline",
      state: "IL",
      zip: "61244",
      phone: "(309) 755-6002",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Moline, approximately 5 miles east of Moline",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves East Moline, Silvis, and eastern Rock Island County. Convenient for residents near the John Deere Harvester Works and QC Airport.",
      icon: "ri-mail-line",
    },
    {
      id: "mln-5",
      name: "Silvis Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1601 1st Ave",
      city: "Silvis",
      state: "IL",
      zip: "61282",
      phone: "(309) 792-1250",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Silvis, approximately 6 miles east of Moline",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Silvis, Carbon Cliff, and eastern Rock Island County. Good option for residents near the QC Airport and IL-5 corridor.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2.75 hour drive to Chicago", fpc: "No — ship from Moline" },
    { feature: "Time Commitment", agency: "5.5+ hour round trip — half day lost", fpc: "Minutes — ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for QC", agency: "No — half a day for the drive", fpc: "Yes — the smart fast solution" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "John Deere Executive Travel Deadlines",
      description: "John Deere World HQ executives and engineers frequently receive short-notice international travel assignments. With the Chicago Passport Agency nearly 3 hours away, there's no practical in-person emergency option. Our courier service is the fastest solution for Quad Cities corporate travelers.",
    },
    {
      icon: "ri-road-map-line",
      title: "Unnecessary Chicago Trip",
      description: "Many Quad Cities travelers think they can 'just drive to Chicago' for an emergency appointment. At 2.75 hours each way plus downtown Chicago traffic and wait times, this is a 5.5+ hour ordeal — half a workday lost that most professionals simply can't afford.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Validity Rule",
      description: "Many Quad Cities international business travelers don't realize that numerous countries require 6 months of passport validity beyond the return date. A passport valid for 4 months means you cannot board for most European and Asian destinations.",
    },
    {
      icon: "ri-image-line",
      title: "QC Photo Standards Inconsistency",
      description: "Photo services across the Quad Cities may not consistently meet federal passport photo standards. John Deere ID photos do not qualify. Always use a dedicated passport photo service for international travel documents.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong Application Form",
      description: "Using DS-82 instead of DS-11 for first-time passports (or vice versa) is the #1 cause of rejection at Moline and Rock Island acceptance facilities. Our document review catches this before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Dual QC Airport Confusion",
      description: "Quad Cities International Airport (MLI) in Moline offers limited international service. Most international flights depart from Chicago O'Hare (ORD) — about 2.5 hours away. Plan your airport logistics and ensure your passport is ready well before heading to Chicago.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Moline or Rock Island County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx on John Deere Road or Avenue of the Cities." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with corporate executive travel, QC family vacations, and international business." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — under 3 hours away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Moline address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Moline, IL?", a: "Fast Passport Center offers emergency passport processing in Moline, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (2 hours 45 minutes east via I-88) — without you making the trip. For Quad Cities residents, this saves a half-day of driving and downtown Chicago navigation." },
    { q: "Does Moline have a passport agency?", a: "No — Moline does not have a regional passport agency. The nearest facility is the Chicago Passport Agency approximately 2 hours 45 minutes east via I-88 and I-290. Fast Passport Center's courier service is the most practical fast option for the Quad Cities — especially for John Deere professionals who can't afford a full day away." },
    { q: "Do you serve John Deere employees and corporate travelers?", a: "Absolutely. Fast Passport Center is deeply experienced with John Deere World Headquarters executive, engineering, and professional travel needs. We understand last-minute international assignments, supplier visits, and corporate event travel. Our 24–48 hour service is ideal for the fast-paced Quad Cities business community." },
    { q: "What airport do Moline travelers use for international flights?", a: "Quad Cities International Airport (MLI) in Moline offers regional flights with connections through Chicago O'Hare. For most international flights, Quad Cities travelers drive or connect through Chicago O'Hare (ORD) — approximately 2.5 hours east. Some also use Des Moines International (DSM) — approximately 2.5 hours west." },
    { q: "Do you serve Rock Island, East Moline, and the Iowa Quad Cities?", a: "Yes — Fast Passport Center serves the entire Quad Cities metropolitan area including Moline, Rock Island, East Moline, Silvis, Carbon Cliff, Hampton, Port Byron, Coal Valley, Milan, and Geneseo on the Illinois side, plus Davenport, Bettendorf, and Eldridge on the Iowa side." },
    { q: "Can I get my child's passport expedited in Moline?", a: "Yes. Fast Passport Center expedites child passports in Moline for minors under 16. Both parents must appear or submit notarized consent. We guide Quad Cities families through the entire DS-11 process for minors." },
    { q: "Where can I get passport photos in Moline?", a: "Walgreens on John Deere Road, CVS on Avenue of the Cities, and the UPS Store in Moline all offer passport photos. The Moline Post Office also provides limited photo services. Photos must be 2x2 inches on a white background." },
    { q: "Is there really no other fast option in the Quad Cities?", a: "Honestly — no. The Chicago Passport Agency is nearly 3 hours away and requires appointments booked weeks in advance for non-emergencies. For urgent international travel from the Quad Cities, Fast Passport Center's courier service is the only practical 24–48 hour option. It's why we're the go-to for John Deere executives and Quad Cities professionals." },
  ],
  photoLocations: [
    { name: "Walgreens — Moline", address: "4000 John Deere Rd, Moline, IL 61265", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Moline", address: "3930 44th Avenue Dr, Moline, IL 61265", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "CVS — Moline", address: "4200 Avenue of the Cities, Moline, IL 61265", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Walgreens — Rock Island", address: "3100 11th St, Rock Island, IL 61201", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Moline", address: "2001 52nd Ave, Moline, IL 61265", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Near SouthPark Mall and John Deere Road. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Rock Island", address: "400 24th St, Rock Island, IL 61201", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Rock Island and western Quad Cities. REAL ID processing available. Located near Augustana College.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for Rock Island County birth and death certificates" },
    { label: "Marriage Licenses (Rock Island County Clerk)", url: "https://www.rockislandcountyil.gov/178/County-Clerk", desc: "Rock Island County Clerk — marriage license applications and certified copies for Moline and Quad Cities" },
    { label: "Divorce Decrees (Rock Island County Circuit Clerk)", url: "https://www.rockislandcountyil.gov/174/Circuit-Clerk", desc: "Rock Island County Circuit Clerk — divorce decree records for Moline and Rock Island County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "MLI",
      name: "Quad Cities International Airport",
      distance: "Approximately 10 minutes south of Moline via IL-5",
      address: "2200 69th Ave, Moline, IL 61265",
      note: "Regional airport serving the Quad Cities with daily flights to Chicago O'Hare, Dallas, Atlanta, and other hubs. Convenient for domestic connections and regional travel. About 10 minutes from downtown Moline.",
      flightUrl: "https://www.qcairport.com/",
      flightLabel: "MLI Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 2 hours 45 minutes east via I-88",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub with extensive global connections. Most Quad Cities international travelers use ORD for direct international flights. About 2.75 hours from Moline — plan ahead.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "Approximately 2 hours 30 minutes west via I-80",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Alternative airport for Quad Cities travelers. Good for Southwest Airlines connections and some international routes. About 2.5 hours from Moline.",
      flightUrl: "https://www.flydsm.com/",
      flightLabel: "DSM Flight Info",
      featured: false,
    },
  ],
};